/**
 * Counter
 */

export default function Counter() {
    const selectors = {
        'counter' : '.js-counter',
    };

    this.init = () => {
        this.counter();
    };

    this.counter = () => {
        jQuery(selectors.counter).counterUp();
    }

}
